module.exports = __webpack_public_path__ + "img/drag_indicator.2df16eef.svg";